import { LoadingModule } from '@techmore/loading';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { TechmoreSharedModule } from '@techmore/share';
import { TransformPipe } from './pipe/transform.pipe';
import { FormsModule } from '@angular/forms';
// import { TechmoreFormModule } from '@techmore/form';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalModule } from '@techmore/global';
// import { UploadModule } from '@techmore/upload';
import { MultiSelectComponent } from './component/multi-select/multi-select.component';
import { HtmlTagSwapPipe } from './pipe/html-tag-swap.pipe';
import { LaziesDirective } from './directive/lazies.directive';
import { LazyImageDirective } from './directive/lazy-image.directive';
import { LockDirective } from './directive/lock-until.directive';
import { PaginationComponent } from './component/pagination/pagination.component';
import { PathPipe } from './pipe/path.pipe';
import { IsInArrayPipe } from './pipe/is-in-array.pipe';
import { BsDropdownStatusDirective } from './directive/bs-dropdown-status.directive';
import { EncodeURIPipe } from './pipe/encode-uri.pipe';
import { BsTabStatusDirective } from './directive/bs-tab-status.directive';
import { AutoCompleteOptionsComponent } from './component/auto-complete-options/auto-complete-options.component';
import { Map2LabelPipe } from './pipe/map2-label.pipe';
import { MatchAnotherArrayPipe } from './pipe/match-another-array.pipe';
import { SideToolboxComponent } from './component/side-toolbox/side-toolbox.component';
import { AuthLicenseDirective } from './directive/auth-license.directive';
import { BsCollapseDirective } from './directive/bs-collapse-status.directive';
import { OpenErrorReportDirective } from './directive/open-error-report.directive';
import { ThemeCollectBtnComponent } from './component/theme-collect-btn/theme-collect-btn.component';
import { Pagination02Component } from '../web-generator/subject-index-section-generator/component/pagination-02/pagination-02.component';
import { BannerHitDirective } from './directive/banner-hit.directive';
import { EncodeBackgroundImageUrlDirective } from './directive/encode-background-image-url.directive';
import { EditableContentPlaceholderDirective } from './directive/editable-content-placeholder.directive';
import { WowControlPanelComponent } from './component/wow-control-panel/wow-control-panel.component';
import { LogHitCountDirective } from './directive/log-hit-count.directive';
import { Base64Pipe } from './pipe/base64.pipe';
import { CopyToClipboardDirective } from './directive/copy-to-clipboard.directive';
import { RepresentItriImageUrlPipe } from './pipe/represent-itri-image-url.pipe';
import { ImgJcropModalComponent } from './component/img-jcrop-modal/img-jcrop-modal.component';
import { EncodeURIComponentPipe } from './pipe/encode-uri-component.pipe';
import { BackgroundImageUrlDirective } from './directive/background-image-url.directive';
import { IsPicSupportImagorDirective } from './directive/is-pic-support-imagor.directive';
import { DCMAuthLicenseDirective } from './directive/dcm-auth-license.directive';
import { FileNameFromUrlPipe } from './pipe/file-name-from-url.pipe';
import { RepresentFilePipe } from './pipe/represent-file.pipe';
import { OldUploadFilePipe } from './pipe/old-upload-file.pipe';
import { Bs5CollapseDirective } from './directive/bs5-collapse.directive';
import { Bs5ModalDirective } from './directive/bs5-modal.directive';
import { Bs4DropdownDirective } from './directive/bs4-dropdown.directive';
import { Bs5DropdownDirective } from './directive/bs5-dropdown.directive';
import { GroupArrayPipe } from './pipe/group-array.pipe';
import { Pagination2Component } from './component/pagination2/pagination2.component';
import { Bs4ModalDirective } from './directive/bs4-modal.directive';


/**
 * 特徵模組
 * 只有高度重複使用的功能放在這裡
 */
@NgModule({
  declarations: [
    MultiSelectComponent,
    PaginationComponent,
    AutoCompleteOptionsComponent,
    SideToolboxComponent,
    Pagination02Component,
    WowControlPanelComponent,
    LaziesDirective,
    LazyImageDirective,
    BsDropdownStatusDirective,
    LockDirective,
    BsTabStatusDirective,
    BsTabStatusDirective,
    AuthLicenseDirective,
    BsCollapseDirective,
    TransformPipe,
    HtmlTagSwapPipe,
    PathPipe,
    IsInArrayPipe,
    Map2LabelPipe,
    MatchAnotherArrayPipe,
    EncodeURIPipe,
    EncodeURIComponentPipe,
    RepresentFilePipe,
    ThemeCollectBtnComponent,
    OpenErrorReportDirective,
    BannerHitDirective,
    EncodeBackgroundImageUrlDirective,
    EditableContentPlaceholderDirective,
    LogHitCountDirective,
    Base64Pipe,
    CopyToClipboardDirective,
    RepresentItriImageUrlPipe,
    ImgJcropModalComponent,
    BackgroundImageUrlDirective,
    IsPicSupportImagorDirective,
    DCMAuthLicenseDirective,
    FileNameFromUrlPipe,
    OldUploadFilePipe,
    Bs4ModalDirective,
    Bs5ModalDirective,
    Bs5CollapseDirective,
    Bs5DropdownDirective,
    Bs4DropdownDirective,
    GroupArrayPipe,
    Pagination2Component,
  ],
  exports: [
    MultiSelectComponent,
    PaginationComponent,
    AutoCompleteOptionsComponent,
    SideToolboxComponent,
    Pagination02Component,
    WowControlPanelComponent,
    LaziesDirective,
    LazyImageDirective,
    BsDropdownStatusDirective,
    BsTabStatusDirective,
    LockDirective,
    AuthLicenseDirective,
    BsCollapseDirective,
    TransformPipe,
    HtmlTagSwapPipe,
    PathPipe,
    IsInArrayPipe,
    Map2LabelPipe,
    MatchAnotherArrayPipe,
    EncodeURIPipe,
    EncodeURIComponentPipe,
    RepresentFilePipe,
    ThemeCollectBtnComponent,
    OpenErrorReportDirective,
    BannerHitDirective,
    EncodeBackgroundImageUrlDirective,
    EditableContentPlaceholderDirective,
    LogHitCountDirective,
    Base64Pipe,
    OldUploadFilePipe,
    CopyToClipboardDirective,
    RepresentItriImageUrlPipe,
    ImgJcropModalComponent,
    BackgroundImageUrlDirective,
    IsPicSupportImagorDirective,
    DCMAuthLicenseDirective,
    FileNameFromUrlPipe,
    Bs4ModalDirective,
    Bs5ModalDirective,
    Bs5CollapseDirective,
    Bs5DropdownDirective,
    Bs4DropdownDirective,
    GroupArrayPipe,
    Pagination2Component,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    GlobalModule,
    // TechmoreFormModule,
    // TechmoreSharedModule,
    TranslateModule.forChild(),
  ]
})
export class ShareModule {
}
